import View from '../../view.js';

class UserRoleRetrieval extends View {
  get dom() {
    return {
      CUSTOMER_DROPDOWN: '#assigned-customers',
      ROLE_DROPDOWN: '#user_role_id',
      USERNAME: '#user_username',
    };
  }

  get events() {
    var events = {};

    events['change ' + this.dom.CUSTOMER_DROPDOWN] = '_reloadRoles';
    return events;
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  _reloadRoles() {
    var self = this;

    $.ajax({
      url: '/' + currentCustomer + '/users/available_roles',
      data: {
        username: $(self.dom.USERNAME).val(),
        assigned_customers: $(self.dom.CUSTOMER_DROPDOWN).val() || [], // eslint-disable-line camelcase
      },
    })
      .done(function (data) {
        self._populateDropdown($(self.dom.ROLE_DROPDOWN), data.roles);
      })
      .fail(function () {
        alert(
          'An error occurred while fetching data. Please try selecting a Store again.',
        );
        self._populateDropdown($(self.dom.ROLE_DROPDOWN), '');
      });
  }

  _populateDropdown(target, data) {
    var previousValues = target.val();

    target = $(target);
    target.select2().html(data);
    target.select2().val(previousValues);
    target.select2({ selectOnBlur: false }).trigger('change');
  }
}

module.exports = UserRoleRetrieval;
